import {
  Button,
  Card,
  Col,
  Divider,
  Row,
  Table,
  Typography,
  Spin,
} from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import garment_img from "../../../assets/dashboard/garment_img.png";
import { useLocation, useNavigate } from "react-router";
import ManageGarmentService from "../../../services/ManageGarmentService";
import ResponseMessage from "../../Comman/Notification/ResponseMessge";

const { Title, Text } = Typography;

const ViewGarment = () => {
  const [displayGarment, setDisplayGarment] = useState([]);
  const [binId, setBinId] = useState();
  const [kanbanEdit, setKanbanEdit] = useState(false);
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const binLocation = decodeURIComponent(queryParams.get("bin_location") || "");

    const userData = JSON.parse(localStorage.getItem("userData"));
    if (userData?.data?.dept === "20" && binLocation.includes("dispatch_center")) {
      setKanbanEdit(true);
    }

    const fetchGarmentByBinId = async () => {
      const binIdFromQuery = queryParams.get("bin_id");

      if (!binIdFromQuery) {
        setDisplayGarment([]);
        setLoading(false);
        return;
      }

      setBinId(binIdFromQuery);

      try {
        setLoading(true);
        const response = await ManageGarmentService.getGarmentBybinId(binIdFromQuery);
        const garments = Array.isArray(response?.data) ? response.data : [];
        setDisplayGarment(garments);
      } catch (error) {
        console.error(error);
        setDisplayGarment([]);
      } finally {
        setLoading(false);
      }
    };

    fetchGarmentByBinId();
  }, [location.search]);

  const handleEditGarment = (editedData) => {
    navigate(
      `/manage-bin/edit/garment?bin_id=${encodeURIComponent(
        binId
      )}&kb_num=${encodeURIComponent(editedData.kanban_no)}`
    );
  };

  const handleDeleteGarment = async (garmentData) => {
    try {
      const updated = displayGarment.filter((g) => g.dbd_id !== garmentData.dbd_id);
      setDisplayGarment(updated);

      const response = await ManageGarmentService.deleteKanbanbyDbd_id(
        garmentData.dbd_id
      );

      if (response) {
        ResponseMessage.success({ message: response.message });
      }
    } catch (error) {
      ResponseMessage.error({ message: "Failed to delete Kanban." });
    }
  };

  const handleAddGarments = () => {
    navigate(`/manage-bin/add-garment?bin_id=${encodeURIComponent(binId)}`);
  };

  return (
    <div className="page-container">
      <style>
        {`
          .info-container {
            display: flex;
            flex-direction: column;
            gap: 8px;
            margin-top: 10px;
          }

          .info-row {
            display: flex;
            justify-content: space-between;
            align-items: center;
            background: #f8fafc;
            padding: 10px 12px;
            border-radius: 10px;
            border: 1px solid #e2e8f0;
            gap: 12px;
          }

          .info-label {
            color: #64748b;
            font-weight: 500;
            font-size: 13px;
            min-width: 70px;
          }

          .info-value {
            color: #0f172a;
            font-weight: 700;
            font-size: 14px;
            text-align: right;
            word-break: break-word;
          }

          .garment-image-wrap {
            text-align: center;
            margin-bottom: 14px;
          }

          .garment-image {
            width: 120px;
            max-width: 100%;
            object-fit: contain;
          }

          .garment-size-table .ant-table-thead > tr > th {
            background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
            color: #475569;
            font-weight: 600;
          }

          .garment-actions {
            display: flex;
            justify-content: flex-end;
            gap: 8px;
            margin-top: 12px;
          }

          .view-garment-loader {
            min-height: 300px;
            display: flex;
            justify-content: center;
            align-items: center;
          }

          .empty-wrap {
            min-height: 220px;
            display: flex;
            justify-content: center;
            align-items: center;
          }
        `}
      </style>

      <div className="page-header">
        <div className="page-title-wrap">
          <Title level={3} className="page-title">
            <ArrowLeftOutlined
              onClick={() => navigate(-1)}
              style={{ marginRight: 10, cursor: "pointer" }}
            />
            View Garments
          </Title>
          <Text className="page-subtitle">
            Manage garments inside selected bin
          </Text>
        </div>

        {/* <Button
          type="primary"
          className="primary-btn"
          onClick={handleAddGarments}
        >
          Add Garment
        </Button> */}
      </div>

      <Divider className="page-divider" />

      {loading ? (
        <div className="view-garment-loader">
          <Spin size="large" tip="Loading garments..." />
        </div>
      ) : displayGarment.length > 0 ? (
        <Row gutter={[16, 16]}>
          {displayGarment.map((garment) => {
            let sizeData = {};
            try {
              sizeData = JSON.parse(garment.size_qty || "{}");
            } catch (e) {
              sizeData = {};
            }

            const filteredSizeData = Object.keys(sizeData)
              .filter((size) => sizeData[size] > 0)
              .reduce((acc, size) => {
                acc[size] = sizeData[size];
                return acc;
              }, {});

            const sizeColumns = Object.keys(filteredSizeData).map((size) => ({
              title: size,
              dataIndex: size,
              key: size,
              align: "center",
            }));

            return (
              <Col xs={24} sm={12} lg={8} key={garment.dbd_id}>
                <Card
                  className="modern-card"
                  title={
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: 12,
                      }}
                    >
                      <span>Kanban</span>
                      <strong style={{ color: "#7c3aed" }}>
                        {garment.kanban_no}
                      </strong>
                    </div>
                  }
                >
                  <div className="garment-image-wrap">
                    <img
                      src={garment_img}
                      alt="Garment"
                      className="garment-image"
                    />
                  </div>

                  <div className="info-container">
                    <div className="info-row">
                      <span className="info-label">Item</span>
                      <span className="info-value">{garment.item_no}</span>
                    </div>

                    <div className="info-row">
                      <span className="info-label">PO</span>
                      <span className="info-value">{garment.po_no}</span>
                    </div>

                    <div className="info-row">
                      <span className="info-label">Country</span>
                      <span className="info-value">{garment.country || "N/A"}</span>
                    </div>

                    <div className="info-row">
                      <span className="info-label">Qty</span>
                      <span className="info-value">{garment.total_qty}</span>
                    </div>

                    <div className="info-row">
                      <span className="info-label">Color</span>
                      <span className="info-value">{garment.color}</span>
                    </div>
                  </div>

                  {sizeColumns.length > 0 && (
                    <Table
                      size="small"
                      columns={sizeColumns}
                      dataSource={[filteredSizeData]}
                      pagination={false}
                      style={{ marginTop: 14 }}
                      className="garment-size-table"
                      rowKey={() => garment.dbd_id}
                    />
                  )}

                  {kanbanEdit && (
                    <div className="garment-actions">
                      <Button onClick={() => handleEditGarment(garment)}>
                        Edit
                      </Button>
                      <Button
                        danger
                        type="primary"
                        onClick={() => handleDeleteGarment(garment)}
                      >
                        Delete
                      </Button>
                    </div>
                  )}
                </Card>
              </Col>
            );
          })}
        </Row>
      ) : (
        <div className="empty-wrap">
          <Text type="secondary">No Garments Found</Text>
        </div>
      )}
    </div>
  );
};

export default ViewGarment;